export const cacheableCallable = <TArgs extends any[], TRet extends any>(
  callable: (...args: TArgs) => Promise<TRet>,
  cacheKeyFunc: (...args: TArgs) => string = (...args) => JSON.stringify(args),
  cacheTimeout: number = 60000
): ((...args: TArgs) => Promise<TRet>) => {
  const cache = new Map<string, TRet>();

  async function getCached(...args: TArgs): Promise<TRet> {
    const key = cacheKeyFunc(...args);

    if (!cache.has(key)) {
      const result = await callable(...args);
      if (result) {
        cache.set(key, result);
        setTimeout(() => cache.delete(key), cacheTimeout);
      }
    }

    return cache.get(key) as TRet;
  }

  return getCached;
};
